"use client";

import { motion } from "framer-motion";
import image1 from "../../assets/campusLife/campusLife1.jpg";
export default function Hero() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const statsVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay: 0.6 },
    },
  };

  return (
    <section className="relative bg-white min-h-screen flex items-center overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 right-20 w-4 h-4 bg-primary/30 rounded-full opacity-80"></div>
        <div className="absolute top-40 right-40 w-2 h-2 bg-primary/30 rounded-full opacity-60"></div>
        <div className="absolute bottom-40 right-32 w-3 h-3 bg-primary/30 rounded-full opacity-70"></div>
        <div className="absolute top-60 right-60 w-1 h-1 bg-primary/30 rounded-full opacity-50"></div>

        {/* Decorative shapes */}
        <div className="absolute bottom-32 right-20 w-8 h-8 border-2 border-black/30 rotate-45"></div>
        <div className="absolute top-32 right-80">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            className="text-black/20"
          >
            <path
              d="M20 0L24.5 15.5L40 20L24.5 24.5L20 40L15.5 24.5L0 20L15.5 15.5L20 0Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="text-black"
          >
            <motion.p
              variants={itemVariants}
              className="text-sm font-medium tracking-wider uppercase mb-6 opacity-90"
            >
              NOT JUST FOR LEISURE
            </motion.p>

            <motion.h1
              variants={itemVariants}
              className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight mb-6"
            >
              &#34;Find your career opportunities with the{" "}
              <span className="text-primary">
                ZUMS Alumni&lsquo;s community
              </span>
              &ldquo;
            </motion.h1>

            <motion.p
              variants={itemVariants}
              className="text-lg lg:text-xl opacity-90 mb-8 leading-relaxed max-w-lg"
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </motion.p>
          </motion.div>

          {/* Right Content - Graduates Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="relative"
          >
            <img
              src={image1}
              alt="Three graduates in caps and gowns"
              className="w-full h-auto rounded-lg"
            />
          </motion.div>
        </div>

        {/* Statistics Cards */}
        <motion.div
          variants={statsVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16"
        >
          <motion.div
            whileHover={{ y: -5 }}
            className=" border-l-4  backdrop-blur-sm rounded-xl p-6 text-black  border-primary"
          >
            <div className="text-3xl font-bold mb-2">24</div>
            <div className="text-sm font-medium mb-1">
              Weekend Holiday with ZUMS Alumni Club
            </div>
            <div className="text-xs opacity-75">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod.
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -5 }}
            className=" border-l-4  backdrop-blur-sm rounded-xl p-6 text-black  border-primary"
          >
            <div className="text-3xl font-bold mb-2">28</div>
            <div className="text-sm font-medium mb-1">
              Club Sponsorships 2020-2021
            </div>
            <div className="text-xs opacity-75">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod.
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -5 }}
            className=" border-l-4  backdrop-blur-sm rounded-xl p-6 text-black  border-primary"
          >
            <div className="text-3xl font-bold mb-2">30</div>
            <div className="text-sm font-medium mb-1">
              An Evening With ZUMS Alumni
            </div>
            <div className="text-xs opacity-75">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod.
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
